import React from 'react';

import useStyles from './useStyles';

export type Props = {
  children: React.ReactNode;
  maxQuestionsPerRow?: number;
};

function QuestionRowLayout({ children, maxQuestionsPerRow = 4 }: Props): React.ReactElement {
  const numOfQuestions = React.Children.count(children);
  const { gridItem, gridRow } = useStyles({
    numOfQuestions,
    maxQuestionsPerRow,
  });

  return (
    <div className={gridRow}>
      {React.Children.map(children, child => (
        <div className={gridItem}>{child}</div>
      ))}
    </div>
  );
}

export default QuestionRowLayout;
